// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


/* ==========================================================================
   THEME ES6 COMPONENTS -- WOOCOMMERCE
   ========================================================================== */









export default class Checkout {


    constructor (options) {

        if ($('form[name="checkout"]').length) {
            this.init(options);
        }

    }

    init(options) {
        this.cacheElements();
        this.customCouponFunctionality();
        this.customGiftcardFunctionality();
    }

    cacheElements() {

    }


    // on this does is fill in a hidden form field and submit that form.
    // The form is default Woocommerce functionality, and handles all errors, etc.
    customCouponFunctionality() {
        $(document).on('click', '.js-checkout-apply-coupon', function(){
            var realCouponForm = $('form.checkout_coupon');
            realCouponForm.find('input[type=text]').val($('.js-coupon-code-field').val());
            realCouponForm.submit();
        });
    }


    // on this does is fill in a hidden form field and submit that form.
    customGiftcardFunctionality() {
        $(document).on('click', '.js-checkout-apply-giftcard', function(){
            var realCouponForm = $('form.wc-givex-checkout-fields');
            realCouponForm.find('input[type=text]').val($('.js-giftcard-code-field').val());
            realCouponForm.submit();
        });
    }




}